query BusinessRuleSelections(
  $orderBy: [BusinessRuleSelectionsOrderBy!]
  $filter: BusinessRuleSelectionFilter
) {
  businessRuleSelections(orderBy: $orderBy, filter: $filter) {
    nodes {
      configurationCategoryId
      businessRuleTypeId
      selectionLabel
      selectionValue
    }
  }
}
